export const GET_BUDGETS_REQUEST = "GET_BUDGETS_REQUEST";
export const GET_BUDGETS_SUCCESS = "GET_BUDGETS_SUCCESS";
export const GET_BUDGETS_FAILED = "GET_BUDGETS_FAILED";
